<div bsModal #loginModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <span>{{"Login" | localize}}</span>
                </h5>
                <button type="button" class="close" [attr.aria-label]="l('Close')" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="kt-login__form">

                    <div class="logo-container">
                        <a (click)="goToHome()" href="">
                            <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo'" alt="logo" height="38" />
                            <img *ngIf="appSession.tenant && appSession.tenant.logoId" [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=light&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId" alt="logo" height="38" />
                        </a>
                    </div>

                    <div class="kt-login__title">
                        <h3 class="m-0">
                            {{ 'Appr_User_Login' | localize }}
                        </h3>
                    </div>
                    <form #loginForm="ngForm" class="kt-form" method="post" novalidate (ngSubmit)="login()">
                        <div style="margin: auto; width: 400px;">

                            <div class="form-group row" *ngIf="false">
                                <div class="login-row">
                                    <label class=""
                                           for="country">{{'Region' | localize}}</label>

                                    <p-dropdown id="country"
                                                class="w-100"
                                                #countryInput="ngModel"
                                                [options]="countries"
                                                [(ngModel)]="selectedCountry"
                                                [ngModelOptions]="{standalone: true}"
                                                optionLabel="name"
                                                [style]="{'width':'100%'}"
                                                [showClear]="true"
                                                placeholder="Select a region">

                                        <ng-template pTemplate="selectedItem">
                                            <div class="country-item d-flex" style="gap: 5px" *ngIf="selectedCountry">
                                                <img [src]="selectedCountry.flagUrl" alt="{{selectedCountry.name}}" class="flag-icon" style="width: 32px" />
                                                <span>{{ selectedCountry.name }}</span>
                                            </div>
                                        </ng-template>

                                        <ng-template let-country pTemplate="item">
                                            <div class="country-item d-flex" style="gap: 5px">
                                                <img [src]="country.flagUrl" alt="{{country.name}}" class="flag-icon" style="width: 32px" />
                                                <span>{{ country.name }}</span>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                                <validation-messages [formCtrl]="countryInput"
                                                     *ngIf="!countryInput.touched"></validation-messages>
                            </div>



                            <div class="form-group row">

                                <div class="login-row">
                                    <label class=""
                                           for="userNameOrEmailAddress">{{'UserNameOrEmail' | localize}} *</label>
                                    <input #userNameOrEmailAddressInput="ngModel"
                                           [(ngModel)]="loginService.authenticateModel.userNameOrEmailAddress"
                                           autoFocus
                                           class="form-control m-input"
                                           type="text"
                                           autocomplete="new-password"
                                           name="userNameOrEmailAddress"
                                           required />
                                </div>
                                <validation-messages [formCtrl]="userNameOrEmailAddressInput"
                                                     *ngIf="!userNameOrEmailAddressInput.touched"></validation-messages>
                            </div>

                            <div class="form-group row">
                                <div class="login-row">
                                    <label class=""
                                           for="password">{{'Password' | localize}} *</label>
                                    <input #passwordInput="ngModel"
                                           [(ngModel)]="loginService.authenticateModel.password"
                                           class="form-control m-input"
                                           type="password"
                                           autocomplete="new-password"
                                           name="password"
                                           required
                                           maxlength="32" />
                                </div>
                                <validation-messages [formCtrl]="passwordInput" *ngIf="!passwordInput.touched"></validation-messages>
                            </div>
                        </div>
                        <!--<div class="form-group mt-4">
                <label class="kt-checkbox">
                    <input class="form-control" [(ngModel)]="loginService.rememberMe" type="checkbox" name="rememberMe" value="true" />{{"RememberMe" | localize}}
                    <span></span>
                </label>
            </div>-->

                        <div class="kt-login__actions">
                            <a routerLink="/account/forgot-password" id="forget-password" class="kt-link kt-login__link-forgot">{{"Plattform_ForgotPasswordClick" | localize}}</a>
                            <button type="submit" class="btn btn-primary btn-elevate kt-login__btn-primary" [disabled]="!loginForm.form.valid">{{"LogIn" | localize}}</button>
                        </div>
                    </form>

                    <!--<div class="kt-login__divider">
            <div class="kt-divider">
                <span></span>
                <span>{{"LoginWith" | localize}}</span>
                <span></span>
            </div>
        </div>

        <div class="kt-login__options" *ngIf="(multiTenancySideIsTeanant || !isMultiTenancyEnabled) && loginService.externalLoginProviders.length > 0">
            <a *ngFor="let provider of loginService.externalLoginProviders" class="btn btn-outline-secondary kt-btn btn-sm" (click)="externalLogin(provider)" title="{{provider.name}}">
                <i class="fab fa-{{provider.icon}}"></i>
                {{provider.name}}
            </a>
        </div>-->

                </div>


                <div class="kt-login__account">
                    <ng-container *ngIf="!isFreeEdition">
                        <span *ngIf="isTenantRegistrationAllowed">
                            <a routerLink="/account/register-tenant">{{"RegisterTenant" | localize}}</a>
                            <span> | </span>
                        </span>
                        <span *ngIf="isSelfRegistrationAllowed">
                            <a routerLink="/account/register">{{"CreateAnAccount" | localize}}</a>
                            <span> | </span>
                        </span>
                    </ng-container>

                    <!--<span *ngIf="!multiTenancySideIsTeanant && isTenantSelfRegistrationAllowed">
            <a routerLink="/account/select-edition">{{"NewTenant" | localize}}</a>
            <span> | </span>
        </span>-->
                    <!--<a routerLink="/account/email-activation" id="email-activation-btn">{{"EmailActivation" | localize}}</a>-->
                </div>
            </div>
        </div>
    </div>
</div>



